import { render, staticRenderFns } from "./BreakInDamagesQuestion.vue?vue&type=template&id=c1ddece0&scoped=true"
import script from "./BreakInDamagesQuestion.vue?vue&type=script&lang=ts"
export * from "./BreakInDamagesQuestion.vue?vue&type=script&lang=ts"
import style0 from "./BreakInDamagesQuestion.vue?vue&type=style&index=0&id=c1ddece0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ddece0",
  null
  
)

export default component.exports